import { useEffect } from 'react';
import storage, { ELENTARI_STORAGE_KEY } from '../../../hooks/useStorage/useStorage';
import { SESSION_ID_HEADER_KEY, restApi } from '../../../services/api';
import type { UserMainStorage } from '../AuthContext';
import { UseStoredSessionSyncParams } from '../types/login.types';
import { resolveStoredSessionChange } from './useStoredSessionSync.utils';

const applyStoredSession = (storedUser: UserMainStorage | undefined): boolean => {
  const change = resolveStoredSessionChange({
    currentSessionId: restApi.headers[SESSION_ID_HEADER_KEY],
    storedUser,
  });

  if (change === 'ignore') {
    return false;
  }

  window.location.reload();
  return true;
};

const useStoredSessionSync = ({ isLoggedIn, logout }: UseStoredSessionSyncParams) => {
  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const onStorageUser = (event: StorageEvent) => {
      if (event.key !== ELENTARI_STORAGE_KEY || !event.newValue) {
        return;
      }

      applyStoredSession(JSON.parse(event.newValue));
    };

    window.addEventListener('storage', onStorageUser);
    return () => window.removeEventListener('storage', onStorageUser);
  }, [isLoggedIn]);

  const handleUnauthorizedSession = async () => {
    if (applyStoredSession(storage.getUser())) {
      return;
    }

    await logout();
  };

  return { handleUnauthorizedSession };
};

export default useStoredSessionSync;
